import { Box, Breadcrumbs, Grid, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StyledCard } from "../StyledCard/StyledCard";
import HomeIcon from "@mui/icons-material/Home";
import { SubTitleWithImage } from "../SubTitle/SubTitle";
interface BreadcumbLink {
  path: string;
  name: string;
}

interface BreadcrumbProps {
  title: string;
  organisationLogo: string;
  links: BreadcumbLink[];
}

export const PageBreadcrumbs = ({
  title,
  organisationLogo,
  links,
}: BreadcrumbProps): JSX.Element => {
  const navigate = useNavigate();
  const handleClick = (path: string) => {
    navigate(path);
  };
  return (
    <StyledCard>
      <Grid container spacing={2} sx={{ padding: "12px", display: "flex" }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", alignContent: "center" }}
        >
          <SubTitleWithImage title={`${title}`} url={organisationLogo} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "2%",
            }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                key={`bread-crumb-zero`}
                underline="hover"
                color="inherit"
                onClick={() => handleClick("/")}
              >
                <HomeIcon />
              </Link>
              {links.map((l, index) => (
                <Link
                  key={`bread-crumb-${index}`}
                  underline="hover"
                  color="inherit"
                  onClick={() => handleClick(l.path)}
                >
                  {index === links.length - 1 ? (
                    <Typography color="text.primary">{l.name}</Typography>
                  ) : (
                    <Typography color="text.secondary">{l.name}</Typography>
                  )}
                </Link>
              ))}
            </Breadcrumbs>
          </Box>
        </Grid>
      </Grid>
    </StyledCard>
  );
};
